import { reduxBatch } from '@manaflair/redux-batch'
import { configureStore } from '@reduxjs/toolkit'
import throttle from 'lodash/throttle'
import {
  DEFAULT_GLOBAL_SETTINGS_STATE,
  GLOBAL_SETTINGS_FONTSIZE_VALUES,
  GLOBAL_SETTINGS_ORIENTATION_VALUES,
  GLOBAL_STATE_NAME,
} from '../../../utils/constants'
import { loadValue, saveValue } from '../../../utils/localStorage'
import { APP_STATE_KEY } from '../common/constants'
import { gaEvents } from './middlewares'
import handleAppEvents from './middlewares/handleAppEvents'
import { rootReducer } from './rootReducer'
import { inputSlice } from './slices/input.slice'
import merge from 'lodash/merge'

export const loadAppState = () => {
  const persistedState = loadValue(APP_STATE_KEY)
  const initialState = inputSlice.getInitialState()
  
  if (persistedState) {
    const persistedSettings = persistedState.calculation?.settings
    const updatedCalcInputState = merge({}, initialState, {settings: persistedSettings})

    return {
      [GLOBAL_STATE_NAME.SETTINGS]: persistedState[GLOBAL_STATE_NAME.SETTINGS],
      calculation: {
        input: updatedCalcInputState,
      },
    }
  }

  return {
    [GLOBAL_STATE_NAME.SETTINGS]: {
      ...DEFAULT_GLOBAL_SETTINGS_STATE,
      orientation: GLOBAL_SETTINGS_ORIENTATION_VALUES.VERTICAL,
      fontSize: GLOBAL_SETTINGS_FONTSIZE_VALUES.COMPACT,
    },
  }
}

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: loadAppState(),
  devTools: process.env.NODE_ENV !== 'production',
  enhancers: (enhancers) => [reduxBatch, ...enhancers, reduxBatch],
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(gaEvents, handleAppEvents),
})

store.subscribe(
  throttle(() => {
    const state = store.getState()
    saveValue(APP_STATE_KEY, {
      [GLOBAL_STATE_NAME.SETTINGS]: state[GLOBAL_STATE_NAME.SETTINGS],
      calculation: {
        settings: state.calculation.input.settings,
      },
    })
  }, 1000),
)
